import { useLayoutEffect, useState } from 'react';

// This function is used when a component need different layout under different width.
const useScreenSize = () => {
    const [screenSize, setScreenSize] = useState([0, 0]);

    useLayoutEffect(() => {
        const updateScreenSize = () => {
            setScreenSize([window.innerWidth, window.innerHeight]);
        };

        window.addEventListener('resize', updateScreenSize);
        updateScreenSize();

        return () => window.removeEventListener('resize', updateScreenSize);
    }, []);

    return screenSize;
};

export default useScreenSize;
